"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearState = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/customer/salesman");
const fetchRequest = () => ({
    type: ActionTypes.FETCH_REQUEST
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (list) => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload: {
        list
    }
});
exports.fetchSuccess = fetchSuccess;
const fetchFailed = (error) => ({
    type: ActionTypes.FETCH_FAILED,
    payload: error
});
exports.fetchFailed = fetchFailed;
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
//# sourceMappingURL=salesman.js.map